import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39;

import { normalizePhoneNumber, PrivateDiningRequestFormTabs } from "@dp/common";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import * as yup from "yup";
import BrandRules from "../../utils/BrandRules";
import moment from "moment-timezone";
import i18next from "i18next";
export var PDPageType;

(function (PDPageType) {
  PDPageType["Home"] = "home";
  PDPageType["Gallery"] = "gallery";
  PDPageType["Plan"] = "plan";
  PDPageType["Amenities"] = "amenities";
  PDPageType["Menu"] = "menu";
  PDPageType["Bridal"] = "bridal";
  PDPageType["Customize"] = "customize";
  PDPageType["Corporate"] = "corporate";
  PDPageType["Celebrations"] = "celebrations";
})(PDPageType || (PDPageType = {}));

export var RestDocumentsType;

(function (RestDocumentsType) {
  RestDocumentsType["SampleMenu"] = "Sample-Menu";
  RestDocumentsType["FloorPlan"] = "Floor-Plan";
  RestDocumentsType["PrintBrochure"] = "Print-Brochure";
})(RestDocumentsType || (RestDocumentsType = {}));

var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;

var _SCHEMA_CONTACT_DETAILS = yup.object({
  firstName: yup.string().trim().min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  lastName: yup.string().trim().min(2, "Min. 2 characters required").max(32, "Max. characters allowed are 32").required("This field is mandatory"),
  email: yup.string().email("Please enter a valid email").required("Please enter a valid email"),
  phone: yup.string().trim().when("phoneCountryCode", {
    is: "INT",
    then: yup.string().trim().required("Please enter a valid phone number"),
    otherwise: yup.string().trim().matches(phoneRegExp, "Please enter a valid phone number").required("Please enter a valid phone number")
  }),
  company: yup.string().trim()
});

var _SCHEMA_EVENT_DETAILS = yup.object({
  selectedDineInDate: yup.string().trim().required("Please select date of visit."),
  selectedDineInTime: yup.string().trim().required("Please select time of visit."),
  noOfGuests: yup.number().when("isGroupDiningSupported", {
    is: true,
    then: yup.number().transform(function (value) {
      return isNaN(value) ? 0 : value;
    }).notRequired(),
    otherwise: yup.number().transform(function (value) {
      return isNaN(value) ? 0 : value;
    }).required("This Field is mandatory").min(1, "".concat(i18next.t("error.private_dining.lessThanOneGuest", {
      defaultValue: "Number of guests cannot be less than 1"
    }) || "Number of guests cannot be less than 1")).max(999, "".concat(i18next.t("error.private_dining.moreThanLimitGuests", {
      defaultValue: "Number of guests cannot be more than 999"
    }) || "Number of guests cannot be more than 999"))
  }),
  selectedPurpose: yup.string().trim().required("Please select the occasion."),
  specialRequests: yup.string().trim().nullable(),
  selectedPartySize: yup.number().transform(function (value) {
    return isNaN(value) ? 0 : value;
  }).when(["isGroupDiningSupported", "doesSelectedRestaurantSupports10PartySize"], {
    is: function is(isGroupDiningSupported) {
      return isGroupDiningSupported;
    },
    then: yup.number().transform(function (value) {
      return isNaN(value) ? 0 : value;
    }).required("This Field is mandatory").when("doesSelectedRestaurantSupports10PartySize", {
      is: true,
      then: yup.number().transform(function (value) {
        return isNaN(value) ? 0 : value;
      }).min(10, "Party Size cannot be less than 10").max(999, "Party Size cannot be more than 999"),
      otherwise: yup.number().transform(function (value) {
        return isNaN(value) ? 0 : value;
      }).min(30, "Party Size cannot be less than 30").max(999, "Party Size cannot be more than 999")
    }),
    otherwise: yup.number().transform(function (value) {
      return isNaN(value) ? 0 : value;
    }).notRequired()
  })
});

var brandCode = {
  "general-og-Logo": "OG",
  "general-longhorn-logo": "LH",
  "general-cheddars-logo": "CS",
  "general-yard-logo": "YH",
  "general-bahama-breeze-logo": "BB",
  "general-capital-logo": "CG",
  "general-eddie-logo": "EV",
  "general-seasons-logo": "S52"
};
var DefaultPageData = '{"privatedining":[{"pageType":"Home","pageName":"Home","content":{"channelType":"WEB","contentIds":["privatediningHomeContent"]}},{"pageType":"Gallery","pageName":"Gallery","content":{"channelType":"WEB","contentIds":["galleryContent"]}},{"pageType":"Floor-Plans","pageName":"Floor Plan","content":{"channelType":"WEB","contentIds":["floorPlanContent"]}},{"pageType":"Amenities","pageName":"Amenities","content":{"channelType":"WEB","contentIds":["amenitiesContent"]}},{"pageType":"Sample Menus","pageName":"Sample Menus","content":{"channelType":"WEB","contentIds":["sampleMenusContent"]}},{"pageType":"Make a Request","pageName":"Make a Request","content":{"channelType":"WEB","contentIds":[]}}]}';
var PrivateDiningModel = (_class = /*#__PURE__*/function () {
  function PrivateDiningModel(platformUtil) {
    _classCallCheck(this, PrivateDiningModel);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor2, this);

    _initializerDefineProperty(this, "_activeTab", _descriptor3, this);

    _initializerDefineProperty(this, "_requestFormActiveTab", _descriptor4, this);

    _initializerDefineProperty(this, "_secondarySub", _descriptor5, this);

    _initializerDefineProperty(this, "_isFirstTime", _descriptor6, this);

    _initializerDefineProperty(this, "_isFirstTimeAtLocation", _descriptor7, this);

    _initializerDefineProperty(this, "_eclubOption", _descriptor8, this);

    _initializerDefineProperty(this, "_secondarySubscriptions", _descriptor9, this);

    _initializerDefineProperty(this, "_errObj", _descriptor10, this);

    _initializerDefineProperty(this, "_dob", _descriptor11, this);

    _initializerDefineProperty(this, "_selectedDineInDate", _descriptor12, this);

    _initializerDefineProperty(this, "_selectedDineInTime", _descriptor13, this);

    _initializerDefineProperty(this, "_noOfGuests", _descriptor14, this);

    _initializerDefineProperty(this, "_selectedPurpose", _descriptor15, this);

    _initializerDefineProperty(this, "_specialRequests", _descriptor16, this);

    _initializerDefineProperty(this, "_firstName", _descriptor17, this);

    _initializerDefineProperty(this, "_lastName", _descriptor18, this);

    _initializerDefineProperty(this, "_email", _descriptor19, this);

    _initializerDefineProperty(this, "_phone", _descriptor20, this);

    _initializerDefineProperty(this, "_company", _descriptor21, this);

    _initializerDefineProperty(this, "_phoneCountryCode", _descriptor22, this);

    _initializerDefineProperty(this, "_diningRequestFormInputRefs", _descriptor23, this);

    _initializerDefineProperty(this, "_showConfirmationPage", _descriptor24, this);

    _initializerDefineProperty(this, "_splInstStatus", _descriptor25, this);

    _initializerDefineProperty(this, "_isChangeLocationModalOpen", _descriptor26, this);

    _initializerDefineProperty(this, "_locationsList", _descriptor27, this);

    _initializerDefineProperty(this, "_isLocationsListLoading", _descriptor28, this);

    _initializerDefineProperty(this, "_selectedLocationState", _descriptor29, this);

    _initializerDefineProperty(this, "_selectedRestDetails", _descriptor30, this);

    _initializerDefineProperty(this, "_isEventDetailsFormChanged", _descriptor31, this);

    _initializerDefineProperty(this, "_isContactDetailsSubmitted", _descriptor32, this);

    _initializerDefineProperty(this, "_selectedPartySize", _descriptor33, this);

    _initializerDefineProperty(this, "_zipCode", _descriptor34, this);

    _initializerDefineProperty(this, "_showCancelPrivateDiningMessage", _descriptor35, this);

    _initializerDefineProperty(this, "_showCallTheRestaurantPopup", _descriptor36, this);

    _initializerDefineProperty(this, "_isPrivateDiningSubmiting", _descriptor37, this);

    _initializerDefineProperty(this, "_isPrivateDiningContent", _descriptor38, this);

    _initializerDefineProperty(this, "_isPDEnabledForSelectedRestaurant", _descriptor39, this);

    makeObservable(this);
  }

  _createClass(PrivateDiningModel, [{
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this2 = this;

      runInAction(function () {
        _this2._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(tab) {
      this._activeTab = tab;
    }
  }, {
    key: "setRequestFormActiveTab",
    value: function setRequestFormActiveTab(activeTab) {
      this._requestFormActiveTab = activeTab;
    }
  }, {
    key: "setSelectedDineInDate",
    value: function setSelectedDineInDate(date) {
      this._selectedDineInDate = date;
    }
  }, {
    key: "setSelectedDineInTime",
    value: function setSelectedDineInTime(time) {
      this._selectedDineInTime = time;
    }
  }, {
    key: "setNoOfGuests",
    value: function setNoOfGuests(number) {
      this._noOfGuests = number;
    }
  }, {
    key: "setSelectedPurpose",
    value: function setSelectedPurpose(purpose) {
      this._selectedPurpose = purpose;
    }
  }, {
    key: "setSpecialRequests",
    value: function setSpecialRequests(request) {
      this._specialRequests = request;
    }
  }, {
    key: "setFirstName",
    value: function setFirstName(firstName) {
      this._firstName = firstName;
    }
  }, {
    key: "setLastName",
    value: function setLastName(lastName) {
      this._lastName = lastName;
    }
  }, {
    key: "setEmail",
    value: function setEmail(email) {
      this._email = email;
    }
  }, {
    key: "setPhone",
    value: function setPhone(phone) {
      if (this.phoneCountryCode === "US") {
        var newNumber = normalizePhoneNumber(phone, this.phone);
        this._phone = newNumber;
      } else {
        this._phone = phone === null || phone === void 0 ? void 0 : phone.replace(/[^\d]/g, "");
      }
    }
  }, {
    key: "setCompany",
    value: function setCompany(company) {
      this._company = company;
    }
  }, {
    key: "setPhoneCountryCode",
    value: function setPhoneCountryCode(phoneCountryCode) {
      this._phoneCountryCode = phoneCountryCode;
      this._phone = "";
    }
  }, {
    key: "setDiningRequestFormInputRefs",
    value: function setDiningRequestFormInputRefs(_ref) {
      this._diningRequestFormInputRefs = _ref;
    }
    /**
     *
     * @param errorKey
     * @returns error message fetched from the respective RB key
     */

  }, {
    key: "getErrorMessagesFromAPI",
    value: function getErrorMessagesFromAPI(errorKey) {
      switch (errorKey) {
        case "selectedDineInDate":
          return i18next.t("error.private_dining.invalidSelectedDineInDate", {
            defaultValue: null
          });

        case "selectedDineInTime":
          return i18next.t("error.private_dining.invalidSelectedDineInTime", {
            defaultValue: null
          });

        case "selectedPartySize":
          return i18next.t("error.private_dining.invalidNumberOfGuests", {
            defaultValue: null
          });

        case "selectedPurpose":
          return i18next.t("error.private_dining.inavlidSelectedPurpose", {
            defaultValue: null
          });

        default:
          return null;
      }
    }
  }, {
    key: "getFormError",
    value: function getFormError(errorKey) {
      var formErrors = Object.assign({}, this.eventDetailsErrors, this.contactDetailsErrors); // as we have to show brand specific error messages, we'll use the message that we get from the RB key(s)

      var errorMessageFromAPI = this.getErrorMessagesFromAPI(errorKey);

      if (formErrors[errorKey]) {
        return errorMessageFromAPI || formErrors[errorKey];
      }

      return "";
    }
  }, {
    key: "setIsEventDetailsFormChanged",
    value: function setIsEventDetailsFormChanged(value) {
      this._isEventDetailsFormChanged = value;
    }
  }, {
    key: "setIsContactDetailsSubmitted",
    value: function setIsContactDetailsSubmitted(value) {
      this._isContactDetailsSubmitted = value;
    }
  }, {
    key: "markEventDetailsDirty",
    value: function markEventDetailsDirty(inputName, newValue) {
      var updatedFormState = {};

      for (var key in this.isEventDetailsFormChanged) {
        if (key === inputName) {
          updatedFormState[key] = newValue;
        } else {
          updatedFormState[key] = this.isEventDetailsFormChanged[key];
        }
      }

      this.setIsEventDetailsFormChanged(updatedFormState);
    }
  }, {
    key: "setSelectedPartySize",
    value: function setSelectedPartySize(size) {
      this._selectedPartySize = size;
    }
  }, {
    key: "setUserData",
    value: function setUserData(userProfile) {
      var _userProfile$defaultP;

      this.setFirstName(userProfile === null || userProfile === void 0 ? void 0 : userProfile.firstName);
      this.setLastName(userProfile === null || userProfile === void 0 ? void 0 : userProfile.lastName);
      this.setEmail(userProfile === null || userProfile === void 0 ? void 0 : userProfile.login);
      this.setPhone(userProfile === null || userProfile === void 0 ? void 0 : (_userProfile$defaultP = userProfile.defaultPhone) === null || _userProfile$defaultP === void 0 ? void 0 : _userProfile$defaultP.phoneNumber);
    }
  }, {
    key: "setShowConfirmationPage",
    value: function setShowConfirmationPage(value) {
      this._showConfirmationPage = value;
    }
  }, {
    key: "setSplInstStatus",
    value: function setSplInstStatus(value) {
      if (!value) {
        this.setSpecialRequests("");
      }

      this._splInstStatus = value;
    }
  }, {
    key: "setZipCode",
    value: function setZipCode(code) {
      this._zipCode = code;
    }
  }, {
    key: "setShowCancelPrivateDiningMessage",
    value: function setShowCancelPrivateDiningMessage(value) {
      this._showCancelPrivateDiningMessage = value;
    }
  }, {
    key: "setShowCallTheRestaurantPopup",
    value: function setShowCallTheRestaurantPopup(value) {
      this._showCallTheRestaurantPopup = value;
    }
  }, {
    key: "setIsPrivateDiningSubmiting",
    value: function setIsPrivateDiningSubmiting(value) {
      this._isPrivateDiningSubmiting = value;
    }
  }, {
    key: "setPageContent",
    value: function setPageContent(_content) {
      this._isPrivateDiningContent = _content;
    }
  }, {
    key: "showSelctedStateByDefault",
    value: function () {
      var _showSelctedStateByDefault = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(restaurantNumber) {
        var selectedRest, _selectedRest$, _selectedRest$$contac, _selectedRest$$contac2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selectedRest = this._locationsList.filter(function (item) {
                  return item.restaurantNumber == restaurantNumber;
                });

                if (selectedRest.length) {
                  this.selectedLocationState = (_selectedRest$ = selectedRest[0]) === null || _selectedRest$ === void 0 ? void 0 : (_selectedRest$$contac = _selectedRest$.contactDetail) === null || _selectedRest$$contac === void 0 ? void 0 : (_selectedRest$$contac2 = _selectedRest$$contac.address) === null || _selectedRest$$contac2 === void 0 ? void 0 : _selectedRest$$contac2.stateName;
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function showSelctedStateByDefault(_x) {
        return _showSelctedStateByDefault.apply(this, arguments);
      }

      return showSelctedStateByDefault;
    }()
  }, {
    key: "activeTab",
    get: function get() {
      return this._activeTab;
    }
  }, {
    key: "requestFormActiveTab",
    get: function get() {
      return this._requestFormActiveTab;
    }
  }, {
    key: "secondarySignupSources",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      var sourcesString = (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$["orderconf-secondary-signup"];
      var sources = sourcesString === null || sourcesString === void 0 ? void 0 : sourcesString.split(",");

      if (sources) {
        return sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
          var _source, _brandNameRegex$exec;

          source = (_source = source) === null || _source === void 0 ? void 0 : _source.replace(/["']/g, "");
          var brandNameRegex = /general-(.*)-[lL]ogo/;
          var brandName = (_brandNameRegex$exec = brandNameRegex.exec(source)) === null || _brandNameRegex$exec === void 0 ? void 0 : _brandNameRegex$exec[1];
          return {
            clubName: brandCode[source],
            imageName: "".concat(brandName, "-club")
          };
        });
      }

      return [];
    }
  }, {
    key: "secondarySub",
    get: function get() {
      return this._secondarySub;
    },
    set: function set(secondarySub) {
      var _this3 = this;

      runInAction(function () {
        _this3._secondarySub = secondarySub;
      });
    }
  }, {
    key: "isFirstTime",
    get: function get() {
      return this._isFirstTime;
    },
    set: function set(isFirstTime) {
      var _this4 = this;

      runInAction(function () {
        _this4._isFirstTime = isFirstTime;
      });
    }
  }, {
    key: "isFirstTimeAtLocation",
    get: function get() {
      return this._isFirstTimeAtLocation;
    },
    set: function set(isFirstTimeAtLocation) {
      var _this5 = this;

      runInAction(function () {
        _this5._isFirstTimeAtLocation = isFirstTimeAtLocation;
      });
    }
  }, {
    key: "eclubOption",
    get: function get() {
      return this._eclubOption;
    },
    set: function set(eclubOption) {
      var _this6 = this;

      runInAction(function () {
        _this6._eclubOption = eclubOption;
      });
    }
  }, {
    key: "secondarySubscriptions",
    get: function get() {
      return this._secondarySubscriptions;
    },
    set: function set(data) {
      var _this7 = this;

      runInAction(function () {
        _this7._secondarySubscriptions = data;
      });
    }
  }, {
    key: "errObj",
    get: function get() {
      return this._errObj;
    },
    set: function set(errObj) {
      var _this8 = this;

      runInAction(function () {
        _this8._errObj = errObj;
      });
    }
  }, {
    key: "dob",
    get: function get() {
      return this._dob;
    },
    set: function set(dob) {
      var _this9 = this;

      runInAction(function () {
        _this9._dob = dob;
      });
    }
  }, {
    key: "selectedDineInDate",
    get: function get() {
      return this._selectedDineInDate;
    }
  }, {
    key: "formattedSelectedDineInDate",
    get: function get() {
      var date = moment(this._selectedDineInDate);
      var today = moment();
      var tomorrow = moment().add(1, "day");

      if (date.isSame(today, "d")) {
        return "Today, ".concat(date.format("MMM D"));
      } else if (date.isSame(tomorrow, "d")) {
        return "Tomorrow, ".concat(date.format("MMM D"));
      } else {
        return date.format("ddd, MMM D,  YYYY");
      }
    }
  }, {
    key: "selectedDineInTime",
    get: function get() {
      return this._selectedDineInTime;
    }
  }, {
    key: "noOfGuests",
    get: function get() {
      return this._noOfGuests;
    }
  }, {
    key: "selectedPurpose",
    get: function get() {
      return this._selectedPurpose;
    }
  }, {
    key: "specialRequests",
    get: function get() {
      return this._specialRequests;
    }
  }, {
    key: "firstName",
    get: function get() {
      return this._firstName;
    }
  }, {
    key: "lastName",
    get: function get() {
      return this._lastName;
    }
  }, {
    key: "email",
    get: function get() {
      return this._email;
    }
  }, {
    key: "phone",
    get: function get() {
      return this._phone;
    }
  }, {
    key: "company",
    get: function get() {
      return this._company;
    }
  }, {
    key: "phoneCountryCode",
    get: function get() {
      return this._phoneCountryCode;
    }
  }, {
    key: "isContactDetailsValid",
    get: function get() {
      return _SCHEMA_CONTACT_DETAILS.isValidSync(this);
    }
  }, {
    key: "contactDetailsErrors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA_CONTACT_DETAILS.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isEventDetailsValid",
    get: function get() {
      return _SCHEMA_EVENT_DETAILS.isValidSync(this);
    }
  }, {
    key: "eventDetailsErrors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA_EVENT_DETAILS.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isChangeLocationModalOpen",
    get: function get() {
      return this._isChangeLocationModalOpen;
    },
    set: function set(value) {
      var _this10 = this;

      runInAction(function () {
        _this10._isChangeLocationModalOpen = value;
      });
    }
  }, {
    key: "selectedLocationState",
    set: function set(value) {
      var _this11 = this;

      runInAction(function () {
        _this11._selectedLocationState = value;
      });
    },
    get: function get() {
      return this._selectedLocationState;
    }
  }, {
    key: "isLocationsListLoading",
    get: function get() {
      return this._isLocationsListLoading;
    },
    set: function set(value) {
      var _this12 = this;

      runInAction(function () {
        _this12._isLocationsListLoading = value;
      });
    }
  }, {
    key: "locationsList",
    get: function get() {
      return this._locationsList;
    },
    set: function set(value) {
      var _this13 = this;

      runInAction(function () {
        _this13._locationsList = value;
      });
    }
  }, {
    key: "allPrivateDiningStates",
    get: function get() {
      var _this$_locationsList, _this$_locationsList$, _this$_locationsList$2;

      return Array.from(new Set((_this$_locationsList = this._locationsList) === null || _this$_locationsList === void 0 ? void 0 : (_this$_locationsList$ = _this$_locationsList.map(function (item) {
        var _item$contactDetail, _item$contactDetail$a;

        var stateName = item === null || item === void 0 ? void 0 : (_item$contactDetail = item.contactDetail) === null || _item$contactDetail === void 0 ? void 0 : (_item$contactDetail$a = _item$contactDetail.address) === null || _item$contactDetail$a === void 0 ? void 0 : _item$contactDetail$a.stateName;
        return stateName;
      })) === null || _this$_locationsList$ === void 0 ? void 0 : (_this$_locationsList$2 = _this$_locationsList$.filter(function (item) {
        return item !== undefined;
      })) === null || _this$_locationsList$2 === void 0 ? void 0 : _this$_locationsList$2.sort()));
    }
  }, {
    key: "sortedPrivateDiningLocations",
    get: function get() {
      var _this14 = this;

      var sortedStates = this._selectedLocationState !== "all" ? [this._selectedLocationState] : this.allPrivateDiningStates;
      var locationList = sortedStates === null || sortedStates === void 0 ? void 0 : sortedStates.map(function (state) {
        var _this14$_locationsLis;

        var locationArray = _this14 === null || _this14 === void 0 ? void 0 : (_this14$_locationsLis = _this14._locationsList) === null || _this14$_locationsLis === void 0 ? void 0 : _this14$_locationsLis.filter(function (location) {
          var _location$contactDeta, _location$contactDeta2, _location$contactDeta3;

          return (location === null || location === void 0 ? void 0 : (_location$contactDeta = location.contactDetail) === null || _location$contactDeta === void 0 ? void 0 : (_location$contactDeta2 = _location$contactDeta.address) === null || _location$contactDeta2 === void 0 ? void 0 : (_location$contactDeta3 = _location$contactDeta2.stateName) === null || _location$contactDeta3 === void 0 ? void 0 : _location$contactDeta3.toLowerCase()) === (state === null || state === void 0 ? void 0 : state.toLowerCase());
        }); // sort restaurants alphabatically

        locationArray.sort(function compare(a, b) {
          if ((a === null || a === void 0 ? void 0 : a.restaurantName) < (b === null || b === void 0 ? void 0 : b.restaurantName)) {
            return -1;
          }

          if ((a === null || a === void 0 ? void 0 : a.restaurantName) > (b === null || b === void 0 ? void 0 : b.restaurantName)) {
            return 1;
          }

          return 0;
        });
        return {
          stateName: state,
          locations: locationArray
        };
      });
      return locationList;
    }
  }, {
    key: "selectedRestDetails",
    set: function set(restDetails) {
      var _this15 = this;

      runInAction(function () {
        _this15._selectedRestDetails = restDetails;
      });
    },
    get: function get() {
      return this._selectedRestDetails;
    }
  }, {
    key: "diningRequestFormInputRefs",
    get: function get() {
      return this._diningRequestFormInputRefs;
    }
  }, {
    key: "isEventDetailsFormChanged",
    get: function get() {
      return this._isEventDetailsFormChanged;
    }
  }, {
    key: "isContactDetailsSubmitted",
    get: function get() {
      return this._isContactDetailsSubmitted;
    }
  }, {
    key: "privateDinePurpose",
    get: function get() {
      var _this$_appAttributes2, _this$_appAttributes3;

      return (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : (_this$_appAttributes3 = _this$_appAttributes2.privateDinePurpose) === null || _this$_appAttributes3 === void 0 ? void 0 : _this$_appAttributes3.map(function (dineInPurpose) {
        return dineInPurpose === null || dineInPurpose === void 0 ? void 0 : dineInPurpose.purpose;
      });
    }
  }, {
    key: "isGroupDiningSupported",
    get: function get() {
      var _this$_appAttributes4;

      return new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes4 = this._appAttributes) === null || _this$_appAttributes4 === void 0 ? void 0 : _this$_appAttributes4.currentConceptCode).isGroupDiningSupported();
    }
  }, {
    key: "selectedPartySize",
    get: function get() {
      return this._selectedPartySize;
    }
  }, {
    key: "partySizeRange",
    get: function get() {
      var pdSelectedGuests = i18next.t("pd-selected-guests", {
        defaultValue: ""
      });
      if (pdSelectedGuests !== null && pdSelectedGuests !== void 0 && pdSelectedGuests.length) return pdSelectedGuests === null || pdSelectedGuests === void 0 ? void 0 : pdSelectedGuests.split(";");
      return [];
    }
  }, {
    key: "showPrivateDining",
    get: function get() {
      var _this$_appAttributes5, _this$_appAttributes6;

      return ((_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : (_this$_appAttributes6 = _this$_appAttributes5.configs) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.showPrivateDining) === "true";
    }
  }, {
    key: "privateDiningTimeSlots",
    get: function get() {
      var _this$_appAttributes7, _this$selectedRestDet, _this$selectedRestDet2, _daysHours$hoursInfo, _daysHours$hoursInfo2, _daysHours$hoursInfo3;

      var availableSlots = [];
      var interval = (_this$_appAttributes7 = this._appAttributes) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.privateDineTimeInterval;
      var selectedDay = moment(this.selectedDineInDate).format("dddd");
      var daysHours = (_this$selectedRestDet = this.selectedRestDetails) === null || _this$selectedRestDet === void 0 ? void 0 : (_this$selectedRestDet2 = _this$selectedRestDet.restaurantHours) === null || _this$selectedRestDet2 === void 0 ? void 0 : _this$selectedRestDet2.find(function (i) {
        return (i === null || i === void 0 ? void 0 : i.day) === selectedDay;
      }); // Operations Hours

      var OPHours = daysHours === null || daysHours === void 0 ? void 0 : (_daysHours$hoursInfo = daysHours.hoursInfo) === null || _daysHours$hoursInfo === void 0 ? void 0 : _daysHours$hoursInfo.find(function (i) {
        return (i === null || i === void 0 ? void 0 : i.hourCode) === "OP";
      });
      var startTime = OPHours === null || OPHours === void 0 ? void 0 : OPHours.startTime;
      var endTime = OPHours === null || OPHours === void 0 ? void 0 : OPHours.endTime; // Private Dining Hours

      var PDHours = daysHours === null || daysHours === void 0 ? void 0 : (_daysHours$hoursInfo2 = daysHours.hoursInfo) === null || _daysHours$hoursInfo2 === void 0 ? void 0 : _daysHours$hoursInfo2.find(function (i) {
        return (i === null || i === void 0 ? void 0 : i.hourCode) === "PD";
      }); // Group Dining Hours

      var GDHours = daysHours === null || daysHours === void 0 ? void 0 : (_daysHours$hoursInfo3 = daysHours.hoursInfo) === null || _daysHours$hoursInfo3 === void 0 ? void 0 : _daysHours$hoursInfo3.find(function (i) {
        return (i === null || i === void 0 ? void 0 : i.hourCode) === "GD";
      }); // if PD Hours returned

      if (PDHours !== null && PDHours !== void 0 && PDHours.startTime && PDHours !== null && PDHours !== void 0 && PDHours.endTime) {
        startTime = PDHours === null || PDHours === void 0 ? void 0 : PDHours.startTime;
        endTime = PDHours === null || PDHours === void 0 ? void 0 : PDHours.endTime;
      } // if GD Hours returned


      if (GDHours !== null && GDHours !== void 0 && GDHours.startTime && GDHours !== null && GDHours !== void 0 && GDHours.endTime && this.isGroupDiningSupported) {
        startTime = GDHours === null || GDHours === void 0 ? void 0 : GDHours.startTime;
        endTime = GDHours === null || GDHours === void 0 ? void 0 : GDHours.endTime;
      }

      var currentTime = moment(startTime, "hh:mm A");

      while (currentTime.isSameOrBefore((_endTime = endTime) !== null && _endTime !== void 0 && _endTime.includes("AM") ? moment(endTime, "hh:mm A").add(1, "d") : moment(endTime, "hh:mm A"))) {
        var _endTime;

        availableSlots.push(currentTime.format("h:mm A"));
        currentTime = currentTime.add(interval, "minutes");
      }

      return availableSlots;
    }
  }, {
    key: "formattedRestaurantNumber",
    get: function get() {
      var _this$selectedRestDet3, _this$selectedRestDet4, _this$selectedRestDet5, _this$selectedRestDet6;

      var phone = (_this$selectedRestDet3 = this.selectedRestDetails) === null || _this$selectedRestDet3 === void 0 ? void 0 : (_this$selectedRestDet4 = _this$selectedRestDet3.contactDetail) === null || _this$selectedRestDet4 === void 0 ? void 0 : (_this$selectedRestDet5 = _this$selectedRestDet4.phoneDetail) === null || _this$selectedRestDet5 === void 0 ? void 0 : (_this$selectedRestDet6 = _this$selectedRestDet5[0]) === null || _this$selectedRestDet6 === void 0 ? void 0 : _this$selectedRestDet6.phoneNumber;
      return normalizePhoneNumber(phone, "");
    }
  }, {
    key: "showConfirmationPage",
    get: function get() {
      return this._showConfirmationPage;
    }
  }, {
    key: "splInstStatus",
    get: function get() {
      return this._splInstStatus;
    }
  }, {
    key: "zipCode",
    get: function get() {
      return this._zipCode;
    }
  }, {
    key: "minPrivateDiningDate",
    get: function get() {
      var _this$_appAttributes8;

      var interval = (_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : _this$_appAttributes8.privateDineDateInterval;
      var currentDate = moment();
      return interval ? currentDate.add(interval, "days").toDate() : moment().toDate();
    }
  }, {
    key: "restClosedDays",
    get: function get() {
      var _this$selectedRestDet7;

      return (_this$selectedRestDet7 = this.selectedRestDetails) === null || _this$selectedRestDet7 === void 0 ? void 0 : _this$selectedRestDet7.closedDays;
    }
  }, {
    key: "showCancelPrivateDiningMessage",
    get: function get() {
      return this._showCancelPrivateDiningMessage;
    }
  }, {
    key: "showCallTheRestaurantPopup",
    get: function get() {
      return this._showCallTheRestaurantPopup;
    }
  }, {
    key: "privateDineDateInterval",
    get: function get() {
      var _this$_appAttributes9;

      return (_this$_appAttributes9 = this._appAttributes) === null || _this$_appAttributes9 === void 0 ? void 0 : _this$_appAttributes9.privateDineDateInterval;
    }
  }, {
    key: "isPrivateDiningSubmiting",
    get: function get() {
      return this._isPrivateDiningSubmiting;
    }
  }, {
    key: "pageContent",
    get: function get() {
      return this._isPrivateDiningContent;
    }
  }, {
    key: "privateDiningConfigs",
    get: function get() {
      var _this$_appAttributes14, _this$_appAttributes15;

      var menuItems;

      if (this.showAdditionalMenuForPDEnabled) {
        var _this$_appAttributes10, _this$_appAttributes11;

        var items = [{
          pageType: "Floor-Plans",
          pageName: "Floor Plan",
          content: {
            channelType: "WEB",
            contentIds: ["floorPlanContent"]
          }
        }, {
          pageType: "Gallery",
          pageName: "Gallery",
          content: {
            channelType: "WEB",
            contentIds: ["galleryContent"]
          }
        }];
        menuItems = JSON.parse((_this$_appAttributes10 = this._appAttributes) === null || _this$_appAttributes10 === void 0 ? void 0 : (_this$_appAttributes11 = _this$_appAttributes10.configs) === null || _this$_appAttributes11 === void 0 ? void 0 : _this$_appAttributes11.privatedining);
        items.forEach(function (item) {
          menuItems.privatedining.splice(items.length - 1, 0, item);
        });
      } else {
        var _this$_appAttributes12, _this$_appAttributes13;

        menuItems = JSON.parse((_this$_appAttributes12 = this._appAttributes) === null || _this$_appAttributes12 === void 0 ? void 0 : (_this$_appAttributes13 = _this$_appAttributes12.configs) === null || _this$_appAttributes13 === void 0 ? void 0 : _this$_appAttributes13.privatedining);
      }

      var parsedConifg = !!((_this$_appAttributes14 = this._appAttributes) !== null && _this$_appAttributes14 !== void 0 && (_this$_appAttributes15 = _this$_appAttributes14.configs) !== null && _this$_appAttributes15 !== void 0 && _this$_appAttributes15.privatedining) ? menuItems : JSON.parse(DefaultPageData);
      return parsedConifg === null || parsedConifg === void 0 ? void 0 : parsedConifg.privatedining;
    }
  }, {
    key: "tabsItemList",
    get: function get() {
      var _this$privateDiningCo, _this$privateDiningCo2; // Revisit this logic with BrandRule


      var privateDiningURLPath = this.privateDiningURLPath;
      return (_this$privateDiningCo = this.privateDiningConfigs) === null || _this$privateDiningCo === void 0 ? void 0 : (_this$privateDiningCo2 = _this$privateDiningCo.map(function (config) {
        var _config$pageType, _config$pageType$spli, _config$pageType$spli2;

        return {
          label: config === null || config === void 0 ? void 0 : config.pageName,
          path: "".concat(privateDiningURLPath, "/").concat(config === null || config === void 0 ? void 0 : (_config$pageType = config.pageType) === null || _config$pageType === void 0 ? void 0 : (_config$pageType$spli = _config$pageType.split(" ")) === null || _config$pageType$spli === void 0 ? void 0 : (_config$pageType$spli2 = _config$pageType$spli.join("-")) === null || _config$pageType$spli2 === void 0 ? void 0 : _config$pageType$spli2.toLowerCase())
        };
      })) === null || _this$privateDiningCo2 === void 0 ? void 0 : _this$privateDiningCo2.slice(0, -1);
    }
  }, {
    key: "restDocuments",
    get: function get() {
      var _this$selectedRestDet8;

      return (_this$selectedRestDet8 = this.selectedRestDetails) === null || _this$selectedRestDet8 === void 0 ? void 0 : _this$selectedRestDet8.restDocuments;
    }
  }, {
    key: "eventGuideLink",
    get: function get() {
      var _this$restDocuments, _this$restDocuments$f;

      var printBrochure = this === null || this === void 0 ? void 0 : (_this$restDocuments = this.restDocuments) === null || _this$restDocuments === void 0 ? void 0 : (_this$restDocuments$f = _this$restDocuments.filter(function (doc) {
        return (doc === null || doc === void 0 ? void 0 : doc.docType) === RestDocumentsType.PrintBrochure;
      })) === null || _this$restDocuments$f === void 0 ? void 0 : _this$restDocuments$f[0];
      return (printBrochure === null || printBrochure === void 0 ? void 0 : printBrochure.docUrl) || "";
    }
  }, {
    key: "floorPlanDownloadLink",
    get: function get() {
      var _this$restDocuments2, _this$restDocuments2$;

      var floorPlan = this === null || this === void 0 ? void 0 : (_this$restDocuments2 = this.restDocuments) === null || _this$restDocuments2 === void 0 ? void 0 : (_this$restDocuments2$ = _this$restDocuments2.filter(function (doc) {
        return (doc === null || doc === void 0 ? void 0 : doc.docType) === RestDocumentsType.FloorPlan;
      })) === null || _this$restDocuments2$ === void 0 ? void 0 : _this$restDocuments2$[0];
      return (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.docUrl) || "";
    }
  }, {
    key: "sampleMenus",
    get: function get() {
      var _this$restDocuments3;

      return this === null || this === void 0 ? void 0 : (_this$restDocuments3 = this.restDocuments) === null || _this$restDocuments3 === void 0 ? void 0 : _this$restDocuments3.filter(function (doc) {
        return (doc === null || doc === void 0 ? void 0 : doc.docType) == RestDocumentsType.SampleMenu;
      });
    }
  }, {
    key: "isPDEnabledForSelectedRestaurant",
    get: function get() {
      var _this$selectedRestDet9,
          _this16 = this;

      if (this !== null && this !== void 0 && (_this$selectedRestDet9 = this.selectedRestDetails) !== null && _this$selectedRestDet9 !== void 0 && _this$selectedRestDet9.restaurantNumber) {
        var _this$locationsList;

        var selectedRest = this === null || this === void 0 ? void 0 : (_this$locationsList = this.locationsList) === null || _this$locationsList === void 0 ? void 0 : _this$locationsList.filter(function (item) {
          var _this16$selectedRestD;

          return (item === null || item === void 0 ? void 0 : item.restaurantNumber) == (_this16 === null || _this16 === void 0 ? void 0 : (_this16$selectedRestD = _this16.selectedRestDetails) === null || _this16$selectedRestD === void 0 ? void 0 : _this16$selectedRestD.restaurantNumber);
        });

        if (selectedRest !== null && selectedRest !== void 0 && selectedRest.length) {
          return true;
        } else {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "hideSecondarySignupSources",
    get: function get() {
      var _this$_appAttributes16, _this$_appAttributes17, _this$_appAttributes18;

      var currentBrand = (_this$_appAttributes16 = this._appAttributes) === null || _this$_appAttributes16 === void 0 ? void 0 : (_this$_appAttributes17 = _this$_appAttributes16.concept) === null || _this$_appAttributes17 === void 0 ? void 0 : (_this$_appAttributes18 = _this$_appAttributes17.conceptCode) === null || _this$_appAttributes18 === void 0 ? void 0 : _this$_appAttributes18.toLowerCase();
      return currentBrand === "cg" || currentBrand === "ev" || currentBrand === "rc";
    }
  }, {
    key: "showInternationalPhoneOption",
    get: function get() {
      var _this$_appAttributes19;

      return new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes19 = this._appAttributes) === null || _this$_appAttributes19 === void 0 ? void 0 : _this$_appAttributes19.currentConceptCode).isInternationalPhoneOptionEnabledForPD();
    }
  }, {
    key: "showPdBackground",
    get: function get() {
      var _this$_appAttributes20;

      return new BrandRules((_this$_appAttributes20 = this._appAttributes) === null || _this$_appAttributes20 === void 0 ? void 0 : _this$_appAttributes20.currentConceptCode).showPdBackground();
    }
  }, {
    key: "privateDiningURLPath",
    get: function get() {
      var _this$_appAttributes21;

      return new BrandRules((_this$_appAttributes21 = this._appAttributes) === null || _this$_appAttributes21 === void 0 ? void 0 : _this$_appAttributes21.currentConceptCode).privateDiningURLPath();
    }
  }, {
    key: "restaurantsThatSupport10Guests",
    get: function get() {
      var _this$_appAttributes22;

      return new BrandRules((_this$_appAttributes22 = this._appAttributes) === null || _this$_appAttributes22 === void 0 ? void 0 : _this$_appAttributes22.currentConceptCode).restaurantsThatSupport10Guests();
    }
  }, {
    key: "doesSelectedRestaurantSupports10PartySize",
    get: function get() {
      var _this$selectedRestDet10, _this$selectedRestDet11;

      var restaurants = this.restaurantsThatSupport10Guests;
      return restaurants === null || restaurants === void 0 ? void 0 : restaurants.includes((_this$selectedRestDet10 = this.selectedRestDetails) === null || _this$selectedRestDet10 === void 0 ? void 0 : (_this$selectedRestDet11 = _this$selectedRestDet10.restaurantNumber) === null || _this$selectedRestDet11 === void 0 ? void 0 : _this$selectedRestDet11.toString());
    }
  }, {
    key: "showAdditionalMenuForPD",
    get: function get() {
      var _this$_appAttributes23;

      return new BrandRules((_this$_appAttributes23 = this._appAttributes) === null || _this$_appAttributes23 === void 0 ? void 0 : _this$_appAttributes23.currentConceptCode).showAdditionalMenuForPD();
    }
  }, {
    key: "showAdditionalMenuForPDEnabled",
    get: function get() {
      var _this$selectedRestDet12, _this$selectedRestDet13;

      var restaurants = this.showAdditionalMenuForPD;
      return restaurants === null || restaurants === void 0 ? void 0 : restaurants.includes((_this$selectedRestDet12 = this.selectedRestDetails) === null || _this$selectedRestDet12 === void 0 ? void 0 : (_this$selectedRestDet13 = _this$selectedRestDet12.restaurantNumber) === null || _this$selectedRestDet13 === void 0 ? void 0 : _this$selectedRestDet13.toString());
    }
  }]);

  return PrivateDiningModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_activeTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_requestFormActiveTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return PrivateDiningRequestFormTabs.EventDetails;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_secondarySub", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isFirstTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isFirstTimeAtLocation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_eclubOption", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_secondarySubscriptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_errObj", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_dob", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_selectedDineInDate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_selectedDineInTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_noOfGuests", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_selectedPurpose", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_specialRequests", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_firstName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_lastName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_email", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_phone", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_company", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_phoneCountryCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "US";
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_diningRequestFormInputRefs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_showConfirmationPage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_splInstStatus", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_isChangeLocationModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "_locationsList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "_isLocationsListLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "_selectedLocationState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "all";
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "_selectedRestDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "_isEventDetailsFormChanged", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      selectedDineInDate: false,
      selectedDineInTime: false,
      noOfGuests: false,
      selectedPurpose: false,
      selectedPartySize: false
    };
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "_isContactDetailsSubmitted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "_selectedPartySize", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "_zipCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "_showCancelPrivateDiningMessage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "_showCallTheRestaurantPopup", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "_isPrivateDiningSubmiting", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "_isPrivateDiningContent", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "_isPDEnabledForSelectedRestaurant", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _applyDecoratedDescriptor(_class.prototype, "activeTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setActiveTab", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setActiveTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "requestFormActiveTab", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "requestFormActiveTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRequestFormActiveTab", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRequestFormActiveTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySignupSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySignupSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySub", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySub"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstTimeAtLocation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstTimeAtLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secondarySubscriptions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "secondarySubscriptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errObj", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errObj"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dob", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dob"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedDineInDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedDineInDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedDineInDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedDineInDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedSelectedDineInDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedSelectedDineInDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedDineInTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedDineInTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedDineInTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedDineInTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noOfGuests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "noOfGuests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setNoOfGuests", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setNoOfGuests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedPurpose", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedPurpose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedPurpose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPurpose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialRequests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialRequests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSpecialRequests", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSpecialRequests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFirstName", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFirstName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLastName", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLastName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "email", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "email"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setEmail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phone", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhone", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "company", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "company"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCompany", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCompany"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneCountryCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phoneCountryCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneCountryCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneCountryCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isContactDetailsValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isContactDetailsValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "contactDetailsErrors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "contactDetailsErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEventDetailsValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEventDetailsValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eventDetailsErrors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eventDetailsErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isChangeLocationModalOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isChangeLocationModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedLocationState", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedLocationState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLocationsListLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLocationsListLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "locationsList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "locationsList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allPrivateDiningStates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allPrivateDiningStates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortedPrivateDiningLocations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortedPrivateDiningLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedRestDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedRestDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "diningRequestFormInputRefs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "diningRequestFormInputRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDiningRequestFormInputRefs", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDiningRequestFormInputRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEventDetailsFormChanged", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEventDetailsFormChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsEventDetailsFormChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsEventDetailsFormChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isContactDetailsSubmitted", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isContactDetailsSubmitted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsContactDetailsSubmitted", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsContactDetailsSubmitted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "privateDinePurpose", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "privateDinePurpose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGroupDiningSupported", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGroupDiningSupported"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedPartySize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedPartySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedPartySize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPartySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "partySizeRange", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "partySizeRange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUserData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUserData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "privateDiningTimeSlots", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "privateDiningTimeSlots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedRestaurantNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "formattedRestaurantNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showConfirmationPage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showConfirmationPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowConfirmationPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowConfirmationPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "splInstStatus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "splInstStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSplInstStatus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSplInstStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "zipCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "zipCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setZipCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setZipCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minPrivateDiningDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "minPrivateDiningDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restClosedDays", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restClosedDays"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCancelPrivateDiningMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCancelPrivateDiningMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowCancelPrivateDiningMessage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowCancelPrivateDiningMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCallTheRestaurantPopup", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCallTheRestaurantPopup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowCallTheRestaurantPopup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowCallTheRestaurantPopup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "privateDineDateInterval", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "privateDineDateInterval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsPrivateDiningSubmiting", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsPrivateDiningSubmiting"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPrivateDiningSubmiting", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPrivateDiningSubmiting"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pageContent", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPageContent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPageContent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "privateDiningConfigs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "privateDiningConfigs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tabsItemList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tabsItemList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restDocuments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restDocuments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eventGuideLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eventGuideLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "floorPlanDownloadLink", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "floorPlanDownloadLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sampleMenus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sampleMenus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPDEnabledForSelectedRestaurant", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPDEnabledForSelectedRestaurant"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideSecondarySignupSources", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideSecondarySignupSources"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showInternationalPhoneOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showInternationalPhoneOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPdBackground", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPdBackground"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "privateDiningURLPath", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "privateDiningURLPath"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantsThatSupport10Guests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantsThatSupport10Guests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doesSelectedRestaurantSupports10PartySize", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "doesSelectedRestaurantSupports10PartySize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAdditionalMenuForPD", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAdditionalMenuForPD"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAdditionalMenuForPDEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAdditionalMenuForPDEnabled"), _class.prototype)), _class);
export { PrivateDiningModel as default };